// extracted by mini-css-extract-plugin
module.exports = {"toggleSwitch":"Switch_toggleSwitch__sWnei","option":"Switch_option__1MBaC","active":"Switch_active__3HjV6"};